<template>
  <div class="home">
    <bannerHeader :ind="0"></bannerHeader>
    <div class="banner">
      <swiper :options="swiperOptionOne" ref="mySwiperOne" class="OneSwiper">
        <swiper-slide class="solon" v-for="(item, x) in bannerlist" :key="x">
          <img :src="item.bg" :data-item="2000" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="sign_up">
        <div class="sign_up_in">
          <div class="search">
            <span>青年竞演报名</span>
            <img src="../assets/img/sign_arrow.png" />
          </div>
          <div class="banner_nav">
            <div
              v-for="(item, index) in navList"
              :key="index"
              class="banner_nav_item"
            >
              <span> {{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="sign_up">
        <div class="sign_up_in">
          <div class="search">
            <span>青年竞演报名</span>
            <img src="../assets/img/sign_arrow.png" />
          </div>
          <div class="banner_nav">
            <div
              v-for="(item, index) in navList"
              :key="index"
              class="banner_nav_item"
            >
              <span> {{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content_bg1">
        <div class="annual_activity"><div class="title">年度活动</div></div>
        <div class="news"></div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import bannerHeader from '@/components/bannerHeader.vue';
import Footer from '@/components/Footer.vue';
export default {
  name: 'HomeView',
  components: { swiper, swiperSlide, bannerHeader, Footer },
  data() {
    return {
      swiperOptionOne: {
        // direction:"horizontal",/*横向滑动*/
        spaceBetween: 0,
        //可见图片张数
        slidesPerView: 1,
        // loopedSlides: 4,// 在loop模式下使用slidesPerView，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)
        loopFillGroupWithBlank: true,
        observer: true, // 改变swiper样式时，自动初始化swiper
        observeParents: true, // 监测swiper父元素，如果有变化则初始化swiper
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        // 默认选中中间一张
        centeredSlides: true,
        // preventClicks: false,//当swiper在触摸时阻止默认事件（preventDefault），用于防止触摸时触发链接跳转。
        //无限循环
        loop: true,
        on: {
          // click(e) {
          //   console.log(e, "2222");
          //   // alert('你点了Swiper');
          //   // console.log(this, "3333");
          //   console.log(e.target.dataset.item, "3333");
          //   window.vm.viewTimeTb({
          //     id: e.target.dataset.item
          //   });
          //   document.documentElement.scrollTop = 0;
          // }
        },
        //自动轮播
        autoplay: true,
        breakpoints: {
          // 320: {
          //   //当屏幕宽度大于等于320
          //   slidesPerView: 1,
          //   spaceBetween: 0
          // },
          // 776: {
          //   //当屏幕宽度大于等于776
          //   slidesPerView: 2,
          //   spaceBetween: 0
          // },
          // 1000: {
          //   //当屏幕宽度大于等于1000
          //   slidesPerView: 3,
          //   spaceBetween: 0
          // }
        },
        // pagination:'.swiper-pagination',
        //小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'fraction',
          //type : 'custom',
          renderBullet: function (index, className) {
            return '<div class="' + className + '"><span></span></div>';
          },
          // bulletElement: 'li',
        },
        //上下按钮点击轮播效果
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      bannerlist: [{ bg: require('../assets/img/banner.png') }],
      navList: [{ name: '古镇嘉年华报名' }, { name: '媒体注册' }],
    };
  },
  mounted() {
    console.log(1111, this.$viewport);
  },
  methods: { infomation(item) {} },
};
</script>
<style>
.swiper-button-next,
.swiper-button-prev {
  width: 48px;
  height: 96px;
  /* background-color: rgba(255, 255, 255, 0.2); */
  position: absolute;
  top: 50%;
}

.swiper-button-next {
  right: 5%;
  background-image: url('../assets/img/homeimgs/y@2x.png') !important;
  background-size: 100% 100%;
  cursor: pointer;
}

.swiper-button-prev {
  left: 5%;
  background-size: 100% 100%;
  background-image: url('../assets/img/homeimgs/z@2x.png') !important;
  cursor: pointer;
}
</style>
<style lang="scss" scoped>
.banner {
  position: relative;
  .solon {
    img {
      height: 100vh;
      width: 100vw;
    }
  }
  .sign_up {
    position: absolute;
    left: 72px;
    bottom: 33px;
    z-index: 3;
    .sign_up_in {
      display: flex;
      .search {
        width: 400px;
        height: 100px;
        line-height: 100px;
        background: rgba(218, 219, 223, 0.45);
        box-shadow: 14px 20px 56px 0px rgba(0, 0, 0, 0.12);
        border-radius: 50px 50px 50px 50px;
        // border: 3px solid rgba(182, 182, 182, 0.5);
        &::after {
          --mask-bg: linear-gradient(red, red);
          --mask-clip: content-box, padding-box;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 400px;
          height: 100px;
          border-radius: 50px;
          padding: 3px 3px 3px 3px;
          background: linear-gradient(
            274deg,
            rgba(182, 182, 182, 0.5),
            rgba(255, 255, 255, 0.5),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 0.5),
            rgba(182, 182, 182, 0.5)
          );
          mask-composite: exclude;
          mask-clip: var(--mask-clip);
          mask-image: var(--mask-bg), var(--mask-bg);
          -webkit-mask-image: var(--mask-bg), var(--mask-bg);
          -webkit-mask-clip: var(--mask-clip);
          -webkit-mask-composite: destination-out;
        }

        display: flex;
        justify-content: center;
        align-items: center;
        span {
          color: #ffffff;
          font-size: 32px;
          flex: 1;
          text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        }
        img {
          width: 72px;
          height: 72px;
          margin-right: 14px;
        }
      }
      .banner_nav {
        display: flex;
        height: 100px;
        align-items: center;
        color: #fff;
        .banner_nav_item {
          width: 400px;
          font-size: 28px;
          span {
            display: inline-block;
            width: 399px;
            border-right: solid 1px #fff;
          }
          &:last-child {
            span {
              border-right: none;
            }
          }
        }
      }
    }
  }
}
.nav {
  padding: 20px 120px;
  height: 100px;
  background: #f0f1f2;
  box-sizing: border-box;

  .sign_up {
    width: 660px;
    background: rgba(218, 219, 223, 0.45);
    border-radius: 30px;
    position: relative;
    .sign_up_in {
      display: flex;
      .search {
        width: 220px;
        height: 60px;
        line-height: 60px;
        background: rgba(218, 219, 223, 0.45);
        box-shadow: 14px 20px 56px 0px rgba(0, 0, 0, 0.3);
        border-radius: 30px;
        // border: 3px solid rgba(182, 182, 182, 0.5);
        &::after {
          --mask-bg: linear-gradient(red, red);
          --mask-clip: content-box, padding-box;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 220px;
          height: 60px;
          border-radius: 30px;
          padding: 2px 2px 2px 2px;
          background: linear-gradient(
            274deg,
            rgba(182, 182, 182, 0.5),
            rgba(255, 255, 255, 0.5),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 0.5),
            rgba(182, 182, 182, 0.5)
          );
          mask-composite: exclude;
          mask-clip: var(--mask-clip);
          mask-image: var(--mask-bg), var(--mask-bg);
          -webkit-mask-image: var(--mask-bg), var(--mask-bg);
          -webkit-mask-clip: var(--mask-clip);
          -webkit-mask-composite: destination-out;
        }

        display: flex;
        justify-content: center;
        align-items: center;
        span {
          color: #2a2a2a;
          font-size: 20px;
          flex: 1;
          text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        }
        img {
          width: 44px;
          height: 44px;
          margin-right: 14px;
        }
      }
      .banner_nav {
        display: flex;
        height: 60px;
        align-items: center;
        color: #2a2a2a;
        .banner_nav_item {
          width: 220px;
          font-size: 20px;
        }
      }
    }
  }
}
.content_bg1 {
  padding: 0 240px;
  background: url('../assets/img/bg1.png') no-repeat left top/100% 100%;
  height: 1772px;
  .annual_activity {
    padding-top: 82px;
    .title {
      writing-mode: vertical-lr; /* 垂直方向，从左到右 */
      color: #424451;
      font-size: 48px;
      font-family: SourceHanSansCN-Bold;
    }
  }
}
</style>
